import React, { FunctionComponent, useState } from 'react';
import { Checkbox, CheckboxGroup } from '../functional/OptionCheckbox';
import { RadioButton, RadioGroup } from '../functional/OptionRadioButton';
import { LightContainer, PaddedLightContainer } from '../styles/ColoredContainers';
import { CopyContainer } from '../styles/CopyContainer';
import { NextButton } from '../styles/LayoutButtons';
import { OptionButtonWidth } from '../styles/OptionButton';
import { TextInput } from '../styles/TextInput';
import { DemoComponent, DemoContainer, DemoHeader } from './Demo';

// Demonstration of basic layout / building block components
export const DemoComponents: FunctionComponent = () => {
  const [radioBtnSelected, setRadioBtnSelected] = useState<string | undefined>(undefined);
  const [checkboxSelected, setCheckboxSelected] = useState<string[] | undefined>([]);

  return (
    <DemoContainer>
      <DemoComponent>
        <DemoHeader>Radio Button</DemoHeader>
        <p>
          <RadioGroup onChange={setRadioBtnSelected} defaultSelected={radioBtnSelected}>
            <RadioButton value="radiobtn1" width={OptionButtonWidth.Middle}>
              Radio Button 1
            </RadioButton>
            <RadioButton value="radiobtn2" width={OptionButtonWidth.Middle}>
              Radio Button 2
            </RadioButton>
          </RadioGroup>
        </p>
      </DemoComponent>

      <DemoComponent>
        <DemoHeader>Checkbox</DemoHeader>
        <p>
          <CheckboxGroup onChange={setCheckboxSelected} defaultSelected={checkboxSelected}>
            <Checkbox value="checkbox1">Checkbox 1</Checkbox>
            <Checkbox value="checkbox2">Checkbox 2</Checkbox>
          </CheckboxGroup>
        </p>
      </DemoComponent>

      <DemoComponent>
        <DemoHeader>NextButton</DemoHeader>
        <p>
          Wrapper to antd Button
          <br />
          &lsquo;base&rsquo; props are passed through to underlying antd button
        </p>
        <p>
          <NextButton>NextButton</NextButton>
        </p>
        <p>
          <NextButton disabled>disabled</NextButton>
        </p>
        <p>
          <NextButton hideArrow>hideArrow</NextButton>
        </p>
      </DemoComponent>

      <DemoComponent>
        <DemoHeader>TextInput</DemoHeader>
        <p>
          <TextInput placeholder="Enter text here" type="text" />
        </p>
      </DemoComponent>

      <DemoComponent>
        <DemoHeader>CopyContainer</DemoHeader>
        <CopyContainer>
          This sets basic margins for copy text
          <br />
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </CopyContainer>
      </DemoComponent>

      <DemoComponent>
        <DemoHeader>LightContainer</DemoHeader>
        <LightContainer>
          A cream container for text
          <br />
          <br />
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </LightContainer>
      </DemoComponent>

      <DemoComponent>
        <DemoHeader>PaddedLightContainer</DemoHeader>
        <PaddedLightContainer>
          A padded cream container for text
          <br />
          Padded at the bottom &amp; sides, left aligned
          <br />
          <br />
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat.
        </PaddedLightContainer>
      </DemoComponent>
    </DemoContainer>
  );
};
